import { useEffect, useRef, useState } from "react";

type Props = {
	maxFakeProgress?: number;
	durationMs?: number;
};

const UploadingProgress = ({ maxFakeProgress = 70, durationMs = 2000 }: Props) => {
	const [progress, setProgress] = useState(0);
	const rafRef = useRef<number | null>(null);
	const startTimeRef = useRef<number | null>(null);

	useEffect(() => {
		const animate = (timestamp: number) => {
			if (!startTimeRef.current) {
				startTimeRef.current = timestamp;
			}

			const elapsed = timestamp - startTimeRef.current;
			const percentage = Math.min((elapsed / durationMs) * maxFakeProgress, maxFakeProgress);

			setProgress(Math.floor(percentage));

			if (percentage < maxFakeProgress) {
				rafRef.current = requestAnimationFrame(animate);
			}
		};

		rafRef.current = requestAnimationFrame(animate);

		return () => {
			if (rafRef.current) cancelAnimationFrame(rafRef.current);
		};
	}, [durationMs, maxFakeProgress]);

	return (
		<div className="flex flex-col w-full gap-2 px-1">
			<span className="text-xs text-indigo-600 font-medium"> Verifying {progress}%</span>

			<div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden">
				<div className="h-full bg-indigo-600 rounded-full transition-all" style={{ width: `${progress}%` }} />
			</div>
		</div>
	);
};

export default UploadingProgress;

